// extracted by mini-css-extract-plugin
module.exports = {"Win3":"Compare_Win3__Kz_RD"};